export default __webpack_public_path__ + "static/media/project5.680c9202.png";